define('collections/vendorsAdmin',["jQuery", "Underscore", "T1", "T1Collection", "models/vendorAdmin", "T1Sortable"], function ($, _, T1, T1Collection, Vendor, Sortable) {
  var sortConfiguration = {
    fields: {
      name: {
        actual: "name",
        display: "alphabetically"
      }
    },
    default: {
      sort_by: "name",
      order_by: "ascending"
    }
  };
  var collection = T1Collection.extend({
    canCache: true,
    cacheDuration: 6e4,
    model: Vendor,
    currentSearchConfig: [],
    searchConfiguration: {
      fields: {
        email: {
          type: "exact"
        },
        is_eligible: {
          type: "enum"
        },
        mm_contract_available: {
          type: "enum"
        },
        vendor_type: {
          type: "enum"
        },
        multiField: {
          type: "multiField"
        }
      }
    },
    urlString: "vendors",
    fetchOptions: {
      sort_by: "-updated_on",
      full: "*"
    },
    getSelected: function () {
      var selectedModels = this.filter(function (model) {
        return model.get("selected") === true;
      });
      return new T1Collection(selectedModels);
    },
    toggleAllSelected: function (isSelected) {
      this.each(function (model) {
        model.set({
          selected: isSelected
        });
      });
    },
    applySearchFilter: function (field, term) {
      var searchType;
      var fieldIndex = -1;
      if (field !== undefined && term !== undefined) {
        searchType = {
          term: term,
          searchField: field
        };
        $.each(this.currentSearchConfig, function (index, value) {
          if (value.searchField === "name|id" && field === "multiField") {
            value.searchField = "multiField";
          }
          if (value.searchField === "multiField" && field === "name|id") {
            value.searchField = "name|id";
          }
          if (value.searchField === field) {
            fieldIndex = index;
            return;
          }
        });
        if (fieldIndex === -1) {
          if (term !== "") {
            this.currentSearchConfig.push(searchType);
          }
        } else {
          if (term === "") {
            this.currentSearchConfig.splice(fieldIndex, 1);
          } else {
            this.currentSearchConfig[fieldIndex] = searchType;
          }
        }
      }
    },
    filterBy: function (field, term, success) {
      var self = this;
      var onSuccess = success || $.noop;
      this.applySearchFilter(field, term);
      this.search.set({
        params: this.currentSearchConfig,
        fetchRequired: true,
        success: function (coll) {
          self.trigger("reset");
          onSuccess(coll);
        }
      });
    }
  });
  return T1.Models.Vendor = Sortable.extendCollection(collection, sortConfiguration);
});
